import { FC, Fragment, ReactNode } from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { domainLinkCreator } from '../../utils/domain-manager';
import isAuthorDomain from '../../utils/is-author-domain';
import isLinkToAnotherWorld from '../../utils/is-link-to-another-world';
import isPrerender from '../../utils/is-prerender';

type DomainSensitiveLinkProps = RouteComponentProps & {
    href: string;
    key?: string;
    omitForBots?: boolean;
    children: ReactNode;
};

const DomainSensitiveLink: FC<DomainSensitiveLinkProps> = ({
    children,
    href,
    key = '',
    location,
    history,
    match,
    omitForBots,
    staticContext,
    ...props
}) => {
    const sensitive = isAuthorDomain() || isLinkToAnotherWorld(href);

    if (omitForBots && isPrerender()) {
        return <>{children}</>;
    }

    return (
        <Fragment key={key}>
            {sensitive && (
                <a {...props} href={domainLinkCreator(href)}>
                    {children}
                </a>
            )}
            {!sensitive && (
                <Link {...props} to={href}>
                    {children}
                </Link>
            )}
        </Fragment>
    );
};

export default withRouter(DomainSensitiveLink);
